import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  AuthFlowRoutesService,
  AuthRedirectService,
  AuthRedirectStorageService,
  RoutingService,
} from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class CustomAuthRedirectService extends AuthRedirectService {
  constructor(
    routing: RoutingService,
    router: Router,
    authRedirectStorageService: AuthRedirectStorageService,
    authFlowRoutesService: AuthFlowRoutesService
  ) {
    super(routing, router, authRedirectStorageService, authFlowRoutesService);
  }

  override redirect(): void {
    this.routing.go('/select-b2bunit');
    this.clearRedirectUrl();
  }
}
